import { PropsWithChildren } from 'react';

import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { experimentsRouteRef } from './routes';

export const experimentsPlugin = createPlugin({
  id: 'confidence-experiments',
  routes: {
    root: experimentsRouteRef,
  },
});

export const ConfidenceExperimentsPage = experimentsPlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceExperimentsPage',
    component: () =>
      Promise.resolve(({ children }: PropsWithChildren) => <>{children}</>),
    mountPoint: experimentsRouteRef,
  }),
);
